import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCbYRhxcdfUrvph3pzHWsNB9I3gLYtesGo",
  authDomain: "huahaoyueyuan-392fc.firebaseapp.com",
  projectId: "huahaoyueyuan-392fc",
  storageBucket: "huahaoyueyuan-392fc.appspot.com",
  messagingSenderId: "1021378479222",
  appId: "1:1021378479222:web:5db6cd332aa7ddac0b0b57",
  measurementId: "G-C1H0RRZT9K"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#9E7736",
      light: "#C5A059",
      dark: "#78540B",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#D4AF37",
      light: "#F8EED7",
      dark: "#8C6826",
      contrastText: "#1C1612",
    },
    background: {
      default: "#FAF8F5",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#1C1612",
      secondary: "#68594F",
    },
  },
  typography: {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    h1: {
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      color: "#1C1612",
      fontWeight: 700,
      fontSize: "2.5rem",
      lineHeight: 1.2,
      letterSpacing: "-0.02em",
    },
    h2: {
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      color: "#1C1612",
      fontWeight: 700,
      fontSize: "2.1rem",
      lineHeight: 1.25,
      letterSpacing: "-0.02em",
    },
    h3: {
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      color: "#1C1612",
      fontWeight: 600,
      fontSize: "1.65rem",
      lineHeight: 1.3,
      letterSpacing: "-0.01em",
    },
    h4: {
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      color: "#9E7736",
      fontWeight: 600,
      fontSize: "1.25rem",
      lineHeight: 1.35,
    },
    h5: {
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      color: "#1C1612",
      fontWeight: 600,
      fontSize: "1.1rem",
    },
    body1: {
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      color: "#68594F",
      fontSize: "0.93rem",
      lineHeight: 1.7,
    },
    body2: {
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      color: "#7E6E64",
      fontSize: "0.85rem",
      lineHeight: 1.6,
    },
  },
  shape: {
    borderRadius: 16,
  },
});


root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
